import createEmptyRecipientWell from 'owa-readwrite-recipient-well/lib/utils/createEmptyRecipientWell';
import { ObservableMap } from 'mobx';
import { createStore } from 'satcheljs';
import createBreadcrumbForCatalogs from '../utils/createBreadcrumbForCatalogs';
import AddCalendarsMenuItemId from './schema/AddCalendarsMenuItemId';
import type AddCalendarsPaneState from './schema/AddCalendarsPaneState';
import { TeamSnapAlertMessageType } from './schema/TeamSnapAlertMessageType';
import { DialogPaneState } from '../store/schema/DialogPaneState';
import type { TeamsTeam, TeamsChannel } from 'owa-teams-sds';

const defaultAddCalendarsStore: AddCalendarsPaneState = {
    showAddCalendarsPanel: undefined,
    dialogPaneState: DialogPaneState.OnePane,
    activePane: undefined,
    panelOpenTimestamp: undefined,
    categoriesCollection: [],
    calendarsCollection: [],
    carouselPage: 0,
    attributions: undefined,
    selectedAddCalendarsMenuItemId: AddCalendarsMenuItemId.LandingPage,
    subscribedHolidayCalendars: [],
    selectedCategoryId: AddCalendarsMenuItemId.LandingPage,
    panelsSaving: new ObservableMap<AddCalendarsMenuItemId, true>(),
    icsFolderId: undefined,
    icsCalendarName: undefined,
    icsFile: undefined,
    showDropHint: false,
    webCalUrl: undefined,
    peoplePickerViewState: createEmptyRecipientWell(),
    personaState: undefined,
    showFindPeople: false,
    isLoadingState: false,
    manageCalendarsInfo: null,
    showShareDialog: false,
    breadcrumbs: [createBreadcrumbForCatalogs(null, null)],
    breadcrumbNavigator: null,
    teamSnapViewState: {
        pendingUpdateOperations: [],
        isSavingChanges: false,
        isRemovingAccount: false,
        isLoading: false,
        alertMessageType: TeamSnapAlertMessageType.None,
    },
    isPanelBrowsing: false,
    teams: new ObservableMap<string, TeamsTeam>(),
    channels: new ObservableMap<string, TeamsChannel>(),
};

export const getStore = createStore<AddCalendarsPaneState>(
    'addCalendarsStore',
    defaultAddCalendarsStore
);
export default getStore;
